import React, { useState } from "react";
import { Button, Col, Form, Modal, Row } from "react-bootstrap";

// css
import styles from "./ConfirmationPop.module.scss";

// img

export const allModels = {
  logout: {
    title: "Do you want to Logout?",
    cancelText: "No",
    confirmText: "Yes",
  },
  delete: {
    title: "Are you sure you want to delete?",
    cancelText: "No",
    confirmText: "Delete",
  },
  archive: {
    title: "Are you sure you want to archive?",
    cancelText: "No",
    confirmText: "Yes",
  },
  active: {
    title: "Are you sure you want to active?",
    cancelText: "No",
    confirmText: "Yes",
  },
  update: {
    title: "Are you sure you want to update?",
    cancelText: "No",
    confirmText: "Update",
  },
  remove: {
    title: "Are you sure you want to remove?",
    cancelText: "No",
    confirmText: "Remove",
  },
  resendAccountActivationMail: {
    title: "Are you sure you want resend account activation mail?",
    cancelText: "No",
    confirmText: "Send",
  },
  pin: {
    title: "Are you sure you want to pin?",
    cancelText: "No",
    confirmText: "Yes",
  },
  unpin: {
    title: "Are you sure you want to unpin?",
    cancelText: "No",
    confirmText: "Yes",
  },
  complete: {
    title: "Are you sure you want to Mark Completed?",
    cancelText: "No",
    confirmText: "Mark Complete",
  },
  pending: {
    title: "Are you sure you want to Mark Incomplete?",
    cancelText: "No",
    confirmText: "Mark Incomplete",
  },
  tasksumbit: {
    title: "Are you sure you want to submit?",
    cancelText: "No",
    confirmText: "Yes",
  },
  completeTask: {
    title: "Are you sure you want to complete? You will no longer be able to submit any future sessions on this task.",
    cancelText: "No",
    confirmText: "Yes",
  },
  completeParentTask: {
    title: "Are you sure you want to complete? Parent will no longer be able to submit any future sessions on this task.",
    cancelText: "No",
    confirmText: "Yes",
  },
  completed: {
    title: "Are you sure you want to Mark Complete?",
    cancelText: "No",
    confirmText: "Mark Complete",
  },
  progress: {
    title: "Are you sure you want to Mark Progress?",
    cancelText: "No",
    confirmText: "Mark Progress",
  },

};

const ConfirmationPop = ({
  confirmation,
  setConfirmation,
  confirmHandler,
  type,
}) => {
  const hideHandler = () => {
    setConfirmation(false);
  };
  return (
    <>
      <Modal
        show={confirmation}
        className={`${styles.ConfirmationPop} transparentModal common-confirmation-modal`}
        onHide={hideHandler}
        backdrop="static"
        keyboard={false}
        centered
      >
        <Modal.Body className={`${styles.modalBody}`}>
          <div className="px-md-5 text-center mx-auto">
            <h3 className={`${styles.modalMessage} m-0 fw-bold themeBlue`}>{allModels[type]?.title}</h3>
            <div className="btnWrpper mt-4 d-flex align-items-center justify-content-center gap-10 d-flex justify-content-center">
              <div className="px-2">
                <Button
                  onClick={hideHandler}
                  className={`${styles.modalButton} fw-sbold d-flex align-items-center justify-content-center commonBtn GreyBtn`}
                >
                  {allModels[type]?.cancelText}
                </Button>
              </div>
              <div className="px-2">
                <Button
                  onClick={confirmHandler}
                  className={`${styles.modalButton} fw-sbold d-flex align-items-center justify-content-center commonBtn`}
                >
                  {allModels[type]?.confirmText}
                </Button>
              </div>
            </div>
          </div>
        </Modal.Body>
      </Modal>
    </>
  );
};

export const ConfirmationPopCustom = ({
  title,
  message,
  onConfirm,
  onCancel,
  confirmBtnText,
  cancelBtnText,
  type,
}) => {
  // Get modal data based on type or use an empty object
  const modalData = allModels[type] || {};

  return (
    <>
      <Modal
        show
        className={`${styles.ConfirmationPop} transparentModal common-confirmation-modal`}
        onHide={onCancel}
        backdrop="static"
        keyboard={false}
        centered
      >
        <Modal.Body className={`${styles.modalBody}`}>
          <div className="px-md-5 text-center mx-auto">
            <h3 className={`${styles.modalMessage} m-0 fw-bold themeBlue`}>
              {title || modalData.title || "Are you sure?"}
            </h3>
            {/* <p className="my-2">{message || modalData.message || ""}</p> */}
            <div className="btnWrpper mt-4 d-flex align-items-center justify-content-center gap-10 d-flex justify-content-center">
              <div className="px-2">
                <Button
                  onClick={onCancel}
                  className={`${styles.modalButton} fw-sbold d-flex align-items-center justify-content-center commonBtn GreyBtn`}
                >
                  {cancelBtnText || modalData.cancelText || "Cancel"}
                </Button>
              </div>
              <div className="px-2">
                <Button
                  onClick={onConfirm}
                  className={`${styles.modalButton} fw-sbold d-flex align-items-center justify-content-center commonBtn`}
                >
                  {confirmBtnText || modalData.confirmText || "Confirm"}
                </Button>
              </div>
            </div>
          </div>
        </Modal.Body>
      </Modal>
    </>
  );
};

export default ConfirmationPop;
